import * as React from 'react';
import styled from 'styled-components'
import {backYouTheme} from '../../../../theme'

export default function Card(props){
    const { 
        id,
        children,
        backgroundImg = "",
        isSelectable = false,
        isSelected = false,
        parentFunction,
        style = 'classic', // classic, outline | default: 'classic'
        borderWidth = 0,
        overlay = true,
        bg = 'dark-blue'
    } = props;

    let styleClass = 'bg-gc-' + bg + ' border-none ';
    if(style == 'outline'){
        styleClass = 'bg-transparent text-gray border-gray outline ';
    }
    styleClass += (props.className ?? '');

    return (
        <Wrapper 
            className={"card py-4 pl-4 " + styleClass}
            style={{
                backgroundImage: backgroundImg != null ? `url("` + backgroundImg + `")` : 'none',
                paddingRight: isSelectable ? "calc(85px + 1.5rem)" : "1.5rem",
                borderWidth: borderWidth
            }}
        >
            {isSelectable && 
                <div 
                    onClick={() => parentFunction(id)}
                    className="selectable-overlay d-flex align-items-center justify-content-end"
                >
                    <div className="selectable-content d-flex align-items-center bg-dark-blue h-100 p-4">
                        <i className={"h1 mt-2 fa-regular " + (isSelected ? "fa-square-check text-gc-orange" : "fa-square text-white")}></i>
                    </div>
                </div>
            }

            {(style == 'classic' && overlay == true) && <div className="overlay"></div>}
            
            {children}
        </Wrapper>
    );
}

const Wrapper = styled.span`
    background-color: #fff;
    position: relative;
    background-size: cover;
    background-position: center;

    &:hover, a:hover {
        text-decoration: none!important;
    }

    a .card {
        transition: .3s;

        &:hover{
            text-decoration: none;
            opacity: .6;

            a{
                text-decoration: none;
            }
        }
    }

    .card {
        a:hover {
            text-decoration: none;
        }
    }

    .outline {
        &:hover {
            border-color: ${backYouTheme.palette.primary.darkBlue}!important;
            color: ${backYouTheme.palette.primary.darkBlue}!important;
        }
    }
    
    .card-header {
        z-index: 10;
        border: none;
        background-color: transparent;
        padding: 0;
        color: ${backYouTheme.palette.primary.darkBlue};

        .btn-option {
            font-size: .7rem;
        }
    }

    .card-body {
        .card {
            height: 85px;
            transition: .3s;
            -webkit-transition: .3s;
            -moz-transition: .3s;
            -ms-transition: .3s;
            -o-transition: .3s;

            &.card-w-50 {
                height: 40px;
                
                &:first-child {
                    margin-bottom: 5px;
                }
            }
    
            &:hover {
                // background-color: #004753!important;
                // color: #fff!important;
                // opacity: .6;
            }
    
            i {
                // font-size: 1rem;
            }
    
            // .h6 {
            // 	line-height: .5rem;
            // }
    
            .small {
                font-size: 80%;
            }
        }
    }

    .card-infos {
		margin: 0;
		padding: 0;
		list-style: none;

		li {
			font-size: .8rem;
			margin-bottom: 0px;

			i {
				margin-right: .1rem;
			}
		}
	}

    .card-disabled {
        pointer-events: none;
    }

    .selectable-overlay {
        cursor: pointer;
        // opacity: .8;
        z-index: 100;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		border-radius: 0.32rem;
        background: transparent linear-gradient(125deg, rgba(255, 255, 255, 0.8) 0%, rgba(239, 242, 243, 0.8) 26%, rgba(193, 206, 208, 0.8) 100%) 0% 0% no-repeat padding-box;

        .selectable-content {
		    border-top-right-radius: 0.32rem;
		    border-bottom-right-radius: 0.32rem;
        }
	}

    .overlay {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		border-radius: 0.32rem;
		// background-image: linear-gradient(125deg, #FFFFFFE6 0%, #EFF2F3EC 26%, #C1CED0 100%);
        background: transparent linear-gradient(125deg, #FFFFFFE6 0%, #EFF2F3EC 26%, #C1CED0 100%) 0% 0% no-repeat padding-box;
	}

    @media (min-width: 1200px) and (max-width: 1390px) {
        .card-body {
            .card {
                i {
                    font-size: 1.2rem;
                }

            }
        }
		.card-btn-text {
			display: none;
		}
	}
`;